var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80371 15.1396C11.6797 15.1396 14.8789 11.9404 14.8789 8.07129C14.8789 4.19531 11.6729 0.996094 7.79688 0.996094C3.92773 0.996094 0.735352 4.19531 0.735352 8.07129C0.735352 11.9404 3.93457 15.1396 7.80371 15.1396ZM7.80371 13.7246C4.66602 13.7246 2.15723 11.2021 2.15723 8.07129C2.15723 4.93359 4.66602 2.41113 7.79688 2.41113C10.9346 2.41113 13.457 4.93359 13.4639 8.07129C13.4707 11.2021 10.9414 13.7246 7.80371 13.7246ZM6.94238 11.5234C7.19531 11.5234 7.40723 11.4004 7.55762 11.168L10.8936 5.96582C10.9893 5.82227 11.0645 5.6582 11.0645 5.50098C11.0645 5.15234 10.7568 4.92676 10.4355 4.92676C10.2236 4.92676 10.0391 5.04297 9.89551 5.27539L6.92188 10.0195L5.38379 8.07812C5.22656 7.87305 5.05566 7.79102 4.85059 7.79102C4.50879 7.79102 4.24219 8.06445 4.24219 8.40625C4.24219 8.57031 4.30371 8.72754 4.41992 8.87109L6.30664 11.1748C6.49805 11.4072 6.69629 11.5234 6.94238 11.5234Z",
    fill: "#32D74B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.99d69e0d2864e372f54e2dd6cdac7452.svg";
export { ForwardRef as ReactComponent };